import React from 'react';
import styles from './Logo.module.css';

interface LogoProps {
  src?: string;
  alt?: string;
}

export function Logo({ src = '/logo-hero.png', alt = 'Voice Cut' }: LogoProps) {
  return (
    <div className={styles.wrap}>
      <span className={styles.halo} aria-hidden="true" />
      <img className={styles.img} src={src} alt={alt} />
    </div>
  );
}
